/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
// import type { LoginUserInfo } from '../../api/me/types'
import type { Action } from 'redux'

export enum CommentActionType {
  CREATE_COMMENT = 'comment/create',
  CREATE_COMMENT_POSITION = 'comment/create-position',
  SET_COMMENTS_POSITION = 'comment/set-position',
  APPEND_COMMENT_POSITION = 'comment/append-position',
  UPDATE_COMMENT = 'comment/update',
  UPDATE_COMMENT_REPLIES = 'comment/update/replies',
  UPDATE_SHOW_COMMENT_BUTTON = 'comment/update/comment-button',
  UPDATE_SHOW_COMMENT_BOX = 'comment/update/comment-box',
  UPDATE_SHOW_COMMENT_LIST = 'comment/update/comment-list',
  UPDATE_COMMENT_BUTTON_POSITION = 'comment/update/comment-button-position',
  UPDATE_SELECTED_RANGE = 'comment/update/selected-range',
  UPDATE_COMMENT_POSITION_ON_CHANGE = 'comment/update/comment-position-on-change',
  UPDATE_PREV_TEXT_AND_SELECTION = 'comment/update/prev-text-and-selection',
  UPDATE_COMMENT_COUNT= 'comment/uptate/count',
}

export type CommentActions = 
CreateCommentAction | 
UpdateCommentAction |
AppendCommentPositionAction | SetCommentPositionAction |
UpdateCommentButtonAction | UpdateCommentBoxAction | UpdateCommentButtonPositionAction| UpdateCommentListAction |
UpdateSelectedRangeAction | UpdateCommentPositionOnChangeAction | UpdatePrevTextAndSelectionAction |
UpdateCommentRepliesAction | 
UpdateCommentCountAction

export interface UpdateCommentButtonAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_SHOW_COMMENT_BUTTON
  state: boolean
}

export interface UpdateCommentBoxAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_SHOW_COMMENT_BOX
  state: boolean
}

export interface UpdateCommentListAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_SHOW_COMMENT_LIST
  state: boolean
}

export interface UpdateCommentButtonPositionAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_COMMENT_BUTTON_POSITION
  state: any
}

export interface UpdateSelectedRangeAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_SELECTED_RANGE
  state: any
}

export interface UpdateCommentPositionOnChangeAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_COMMENT_POSITION_ON_CHANGE
  state: any
}

export interface UpdatePrevTextAndSelectionAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_PREV_TEXT_AND_SELECTION
  state: any
}

export interface CreateCommentAction extends Action<CommentActionType> {
  type: CommentActionType.CREATE_COMMENT
  state: any
}

export interface CreateCommentPositionAction extends Action<CommentActionType> {
  type: CommentActionType.CREATE_COMMENT_POSITION
  state: any
}

export interface SetCommentPositionAction extends Action<CommentActionType> {
  type: CommentActionType.SET_COMMENTS_POSITION
  state: any
}
export interface AppendCommentPositionAction extends Action<CommentActionType> {
  type: CommentActionType.APPEND_COMMENT_POSITION
  state: any
}

export interface UpdateCommentAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_COMMENT
  state: any
}

export interface UpdateCommentRepliesAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_COMMENT_REPLIES
  state: any
}

export interface UpdateCommentCountAction extends Action<CommentActionType> {
  type: CommentActionType.UPDATE_COMMENT_COUNT
  count: number
}

export type OptionalCommentState = {
  hiddenCommentBox: boolean;
  hiddenCommentButton: boolean;
  commentButtonPosition: Object;
  selectedRange: Object | null;
  comments: String[];
  positions: Object[];
  prevMarkdown: string;
  prevSelection: Object;
  hiddenCommentList: boolean;
  replies: Object[];
  count: number;
}
